import { useParams, useNavigate } from 'react-router-dom'
import { usePoint } from '@/modules/points/hooks/usePoint'
import { usePointMutation } from '@/modules/points/hooks/usePointMutation'
import { PointDetail } from '@/modules/points/components/PointDetail'
import { ErrorState } from '@/shared/components/ui/atoms/ErrorState'

export function PointDetailPage() {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const pointId = Number(id)
  const { data: point, related, isLoading, error } = usePoint(pointId)
  const { invalidatePoint, isSubmitting: isInvalidating } = usePointMutation()

  if (isLoading) {
    return <div className="animate-pulse h-96 bg-gray-100 rounded-lg" />
  }

  if (error) {
    return <ErrorState message={error} />
  }

  if (!point) return null

  const handleInvalidate = async () => {
    await invalidatePoint(pointId, point.id_client)
    navigate('/points')
  }

  return (
    <PointDetail
      point={point}
      client={related.client}
      user={related.user}
      branch={related.branch}
      onInvalidate={handleInvalidate}
      isInvalidating={isInvalidating}
    />
  )
}
